import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { DeviceSelectionPage, LanguageProvider } from './pages/Common';
import WelcomePage from './pages/WelcomePage';
import PrivacyConsentPage from './pages/PrivacyConsentPage';
import AssessmentPage from './pages/AssessmentPage';
import ResultsPage from './pages/ResultsPage';
import PaymentPage from './pages/PaymentPage';
import SuccessPage from './pages/SuccessPage';
import BookAppointmentPage from './pages/BookAppointmentPage';
import InstallPage from './pages/InstallPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPage from './pages/AdminPage';

// Privacy consent guard
const PrivacyGuard = ({ children }) => {
  const hasAccepted = localStorage.getItem('privacy_accepted');
  if (!hasAccepted) {
    return <Navigate to="/privacy-consent" replace />;
  }
  return children;
};

// Admin auth guard
const AdminGuard = ({ children }) => {
  const isLoggedIn = localStorage.getItem('admin_logged_in');
  if (!isLoggedIn) {
    return <Navigate to="/admin-login" replace />;
  }
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WelcomePage />} />
            <Route path="/install" element={<InstallPage />} />
            <Route path="/privacy-consent" element={<PrivacyConsentPage />} />
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/device-selection" element={
              <PrivacyGuard>
                <DeviceSelectionPage />
              </PrivacyGuard>
            } />
            <Route path="/assessment" element={
              <PrivacyGuard>
                <AssessmentPage />
              </PrivacyGuard>
            } />
            <Route path="/results" element={
              <PrivacyGuard>
                <ResultsPage />
              </PrivacyGuard>
            } />
            <Route path="/payment" element={
              <PrivacyGuard>
                <PaymentPage />
              </PrivacyGuard>
            } />
            <Route path="/success" element={
              <PrivacyGuard>
                <SuccessPage />
              </PrivacyGuard>
            } />
            <Route path="/book-appointment" element={
              <PrivacyGuard>
                <BookAppointmentPage />
              </PrivacyGuard>
            } />
            <Route path="/admin" element={
              <AdminGuard>
                <AdminPage />
              </AdminGuard>
            } />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
